var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{ref:"canvas",staticClass:"qrcode-canvas",attrs:{"width":"1000","height":"1000"}})}
var staticRenderFns = []

export { render, staticRenderFns }